import { pipe } from "fp";

import * as Data from "~/Data";
import * as ELD from "~/ELD";

export type Count = {
  readonly successful: number;
  readonly unsuccessful: number;
};

export const empty = (): Count => ({ successful: 0, unsuccessful: 0 });
export const total = ({ successful, unsuccessful }: Count): number =>
  successful + unsuccessful;

export const use = (): Count =>
  pipe(
    ELD.useStore(),
    Data.Store.toCache,
    Data.Cache.reduce(
      empty(),
      (_id, { successful, unsuccessful }, { submission: { status } }) =>
        ELD.Submission.Status.isSuccess(status)
          ? { unsuccessful, successful: successful + 1 }
          : { unsuccessful: unsuccessful + 1, successful }
    )
  );
